import React from 'react'
import { Link } from 'react-router-dom'
import "./aboutcomp.css"
import Mern from "../assets/mern.png"
import Full from "../assets/full.png"

const AboutComp = () => {
    return (
        <>
            <div className="about">
                <h1 className="about-heading">About Me</h1>
                <div className="about-content">
                    <div className="left">
                        <h1>Who Am I?</h1>
                        <p>
                            I'm a MERN Stack and Full Stack Developer. I
                            Create Fully Responsive and Secure Websites
                            for my Clients 
                        </p>
                        <Link to="contact">
                            <button className='btn'>CONTACT</button>
                        </Link>
                    </div>
                    <div className="right">
                        <div className="img-container">
                            <div className="imgs top">
                                <img src={Mern} className="img" alt="Mern" />
                            </div>
                            <div className="imgs bottom">
                                <img src={Full} className="img" alt="Full" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutComp